import { Directive, ElementRef, inject } from '@angular/core';

/**
 * Directive for projecting trailing icon into a chip. Based on Angular Material MatChipTrailingIcon pattern.
 *
 * @example
 *   ```html
 *   <harmony-chip label="Alert">
 *     <svg hxChipTrailingIcon><use xlink:href="#alert-icon" /></svg>
 *   </harmony-chip>
 *   ```;
 */
@Directive({
  selector: 'svg[hxChipTrailingIcon], [hxChipTrailingIcon]',
  standalone: true,
  host: {
    class: 'hx-chip-trailing-icon',
    '[attr.role]': '"img"',
  },
})
export class HxChipTrailingIcon {
  protected readonly _elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
}
